import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { handleActions } from 'redux-actions';
import { reduxKey, defaultState } from './constants';
import { setScreenSize, initStash } from './actions';
const actionHandlers = handleActions({
    [setScreenSize.toString()]: (state, action)=>_object_spread_props(_object_spread({}, state), {
            viewOptions: _object_spread_props(_object_spread({}, state.viewOptions), {
                screenSize: action.payload
            })
        }),
    [initStash.toString()]: (state, action)=>_object_spread_props(_object_spread({}, state), {
            stash: action.payload.stash
        })
}, defaultState);
export default {
    [reduxKey]: actionHandlers
};

//# sourceMappingURL=reducer.js.map